<h1 class="text-center border-bottom pb-3">SOS-mail INDI-ordernummers</h1>
<div
  class="row"
  [ngClass]="{ 'd-none': feedbackSettings.show || sosCustomers.length > 0 }"
>
  <div class="w-65 p-3 col-md-8 offset-md-2">
    <p class="mb-0">
      Maak een
      <a href="https://en.wikipedia.org/wiki/Mailto" target="_blank"
        >mailto-link</a
      >
      aan de hand van INDI-ordernummers.
    </p>
    <p class="mb-1">
      Plak alle INDI-ordernummers in het onderstaande teksts veld en druk op
      'Opvragen'
    </p>
    <div class="d-flex flex-column">
      <div class="form-group pb-1">
        <label for="indiOrdernumbersId">INDI ordernummers</label>
        <textarea
          class="form-control"
          id="indiOrdernumbersId"
          rows="5"
          #indiOrdernumbersInput="ngModel"
          [(ngModel)]="indiOrdernumbers"
          name="indiOrdernumbersName"
          placeholder="INDI ordernummers hier"
          required
          pattern="(\s*[\d\n]+\s*)+"
          [ngClass]="{
            'is-invalid':
              indiOrdernumbersInput.touched && !indiOrdernumbersInput.valid!
          }"
        ></textarea>
        <div class="invalid-feedback">
          <!-- text-danger is-invalid -->
          In het 'INDI ordernummers'-veld mogen alleen INDI ordernummers staan,
          op elke regel 1.
        </div>
      </div>
      <div class="form-group align-self-end pt-1">
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="!indiOrdernumbersInput.valid!"
          (click)="getSOSCustomers()"
        >
          Opvragen
        </button>
      </div>
    </div>
  </div>
</div>
<div class="d-flex justify-content-center my-5">
  <app-feedback [(settings)]="feedbackSettings"></app-feedback>
</div>
<div>
  <app-sos-customer-list
    [didSearch]="didSearch"
    [sosCustomers]="sosCustomers"
  ></app-sos-customer-list>
</div>
<div [ngClass]="{ 'd-none': !isLoading }">
  <app-loading-gears></app-loading-gears>
</div>
